import { render, staticRenderFns } from "./AutoResponse.vue?vue&type=template&id=04e63331"
import script from "./AutoResponse.vue?vue&type=script&lang=js"
export * from "./AutoResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e63331')) {
      api.createRecord('04e63331', component.options)
    } else {
      api.reload('04e63331', component.options)
    }
    module.hot.accept("./AutoResponse.vue?vue&type=template&id=04e63331", function () {
      api.rerender('04e63331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/AutoResponse.vue"
export default component.exports